import apiClient from './client';

export type Permission = 'read' | 'write' | 'delete' | 'deploy' | 'manage_projects' | 'manage_users' | 'admin';
export type Visibility = 'private' | 'org' | 'public';

export const PERMISSION_LABELS: Record<Permission, string> = {
  read:            'Lecture',
  write:           'Écriture',
  delete:          'Suppression',
  deploy:          'Déploiement',
  manage_projects: 'Gérer projets',
  manage_users:    'Gérer utilisateurs',
  admin:           'Administration',
};

export interface ProjectMember {
  user_id:     string;
  full_name:   string;
  email:       string;
  global_role: string;
  permissions: Permission[];
  added_at:    string;
}

export interface ProjectGroup {
  group_id:           string;
  name:               string;
  description:        string;
  group_permissions:  Permission[];
  member_count:       number;
  added_at:           string;
}

export interface ProjectTeam {
  team_id:      string;
  name:         string;
  color:        string;
  member_count: number;
  added_at:     string;
}

export interface ProjectAccess {
  visibility: Visibility;
  members:    ProjectMember[];
  groups:     ProjectGroup[];
  teams:      ProjectTeam[];
}

export async function getProjectAccess(projectId: string): Promise<ProjectAccess> {
  const res = await apiClient.get(`/api/projects/${projectId}/access`);
  return res.data;
}

export async function getMyProjectPermissions(projectId: string): Promise<{ permissions: Permission[]; has_access: boolean }> {
  const res = await apiClient.get(`/api/projects/${projectId}/access/me`);
  return res.data;
}

export async function setProjectVisibility(projectId: string, visibility: Visibility): Promise<void> {
  await apiClient.patch(`/api/projects/${projectId}/access/visibility`, { visibility });
}

export async function addProjectMember(projectId: string, userId: string, permissions: Permission[]): Promise<void> {
  await apiClient.post(`/api/projects/${projectId}/access/members`, { user_id: userId, permissions });
}

export async function removeProjectMember(projectId: string, userId: string): Promise<void> {
  await apiClient.delete(`/api/projects/${projectId}/access/members/${userId}`);
}

export async function addProjectGroup(projectId: string, groupId: string): Promise<void> {
  await apiClient.post(`/api/projects/${projectId}/access/groups`, { group_id: groupId });
}

export async function removeProjectGroup(projectId: string, groupId: string): Promise<void> {
  await apiClient.delete(`/api/projects/${projectId}/access/groups/${groupId}`);
}

export async function addProjectTeam(projectId: string, teamId: string): Promise<void> {
  await apiClient.post(`/api/projects/${projectId}/access/teams`, { team_id: teamId });
}

export async function removeProjectTeam(projectId: string, teamId: string): Promise<void> {
  await apiClient.delete(`/api/projects/${projectId}/access/teams/${teamId}`);
}
